import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/totalRevenueSalesSagas";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import DatePicker from "./smartComponents/datePicker";
import PeriodType from "./smartComponents/periodType";
import IncludeReturns from "./smartComponents/includeReturns";
import ShowExpenses from "./smartComponents/showExpenses";
import CustomDateRanges from "./smartComponents/customDateRanges";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

import "./totalRevenueSalesModule.css";

function TotalRevenueSalesModule(props) {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.totalRevenueSales.isLoading);
  const initialRequest = useSelector((state) => state.totalRevenueSales.initialRequest);
  const currencySymbol = useSelector((state) => state.commonReducer.commonProps.currencySymbol);

  const { includeReturns = "", showExpenses = "" } = useSelector(
    (state) => state.totalRevenueSales.filters.toggles
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  return (
    <div id="total-revenue-sales-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Total Revenue"
        customClass="total-revenue-sales-section"
        isLoading={isLoading}
        content={
          <div>
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filter">
                <div>
                  <div>
                    {includeReturns && (
                      <div className="select-box-no-width">
                        <p>{includeReturns.label}</p>
                        <IncludeReturns label={includeReturns.label} />
                      </div>
                    )}

                    {showExpenses && (
                      <div className="select-box-no-width">
                        <p>{showExpenses.label}</p>
                        <ShowExpenses label={showExpenses.label} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="top-right-filter">
                  <div className="select-box-no-width">
                    <p>Period Type</p>
                    <PeriodType />
                  </div>
                  <div className="select-box-no-width date-range-select-box">
                    <p>Date Range</p>
                    <CustomDateRanges />
                  </div>

                  <div className="date-select-box select-box-no-width multi">
                    <p>Date</p>
                    <DatePicker />
                  </div>
                  <UpdateBtns />
                </div>
              </div>
            </div>
            <div className="chart-root">
              <TableOrStackedBarChart currencySymbol={currencySymbol} />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default memo(TotalRevenueSalesModule);
